import { FetchStatusSelector } from "@obg/ngrx-utils";

import { CoreState } from "../../state";
import { VerificationStatus } from "../auth-transaction.model";

import { ACTION_PREFIX } from "./smart-id-auth-transaction.action";

export namespace SmartIdAuthTransactionSelector {
	export const isBusy = (state: CoreState): boolean => FetchStatusSelector.isBusy(ACTION_PREFIX)(state);

	export const getLastActivePersonalNumber = (state: CoreState): string | undefined =>
		state.smartIdAuthTransaction.lastActivePersonalNumber;

	export const getLastStatus = (state: CoreState): VerificationStatus | undefined =>
		state.smartIdAuthTransaction.verificationStatus;

	export const getVerificationCode = (state: CoreState): string | undefined =>
		state.smartIdAuthTransaction.verificationCode;

	export const getAuthenticationToken = (state: CoreState): string | undefined =>
		state.smartIdAuthTransaction.authenticationToken;

	export const getTransactionId = (state: CoreState): string | undefined =>
		state.smartIdAuthTransaction.transactionId;
}
